import { useEffect, useState } from "react";
import { api } from "../services/api";
import { 
  Upload, 
  Trash2, 
  Save, 
  MapPin, 
  Building, 
  Palette, 
  Image as ImageIcon, 
  Loader2,
  PanelBottom,
  MonitorPlay,
  Globe // Ícone para o Favicon da aba do navegador
} from "lucide-react";
import "./Dashboard.css";

export default function Dashboard() {
  const [site, setSite] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  // Estados para gerenciar os arquivos das imagens
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [fundoSelecionado, setFundoSelecionado] = useState(null);
  const [faviconSelecionado, setFaviconSelecionado] = useState(null); // <-- NOVO: Favicon

  useEffect(() => {
    loadSite();
  }, []);

  async function loadSite() {
    try {
      const siteId = localStorage.getItem("siteId");

      if (!siteId) {
        alert("Sessão inválida. Por favor, faça login novamente.");
        return;
      }

      const response = await api.get(`/sites/${siteId}`);
      
      const siteData = response.data;
      if (!siteData.rodape) {
        siteData.rodape = {};
      }
      
      setSite(siteData);
      
    } catch (error) {
      console.error("Erro ao carregar dados do site:", error);
      alert("Erro ao carregar as informações do instituto.");
    }
  }

  // Lida com a seleção da Logo
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setArquivoSelecionado(e.target.files[0]);
    }
  };

  // Lida com a seleção da Imagem de Fundo
  const handleFundoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFundoSelecionado(e.target.files[0]);
    }
  };

  // Lida com a seleção do Favicon <-- NOVO
  const handleFaviconChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFaviconSelecionado(e.target.files[0]);
    }
  };

  const handleRodapeChange = (campo, valor) => {
    setSite(prevSite => ({
      ...prevSite,
      rodape: {
        ...prevSite.rodape,
        [campo]: valor
      }
    }));
  };

  const handleUpdateSite = async (currentData) => {
    setIsLoading(true);
    try {
      let logoUrl = currentData.logo;
      let fundoUrl = currentData.imagem_fundo;
      let faviconUrl = currentData.favicon; // <-- NOVO

      // 1. Upload da Logo
      if (arquivoSelecionado) {
        const formDataS3 = new FormData();
        formDataS3.append("file", arquivoSelecionado);
        formDataS3.append("cliente_id", currentData.id);

        const resS3 = await fetch("/api/upload", {
          method: "POST",
          body: formDataS3,
        });

        if (!resS3.ok) throw new Error("Erro no upload da logo");
        const dataS3 = await resS3.json();
        logoUrl = dataS3.url;
      }

      // 2. Upload da Imagem de Fundo
      if (fundoSelecionado) {
        const formDataFundo = new FormData();
        formDataFundo.append("file", fundoSelecionado);
        formDataFundo.append("cliente_id", currentData.id);

        const resFundo = await fetch("/api/upload", {
          method: "POST",
          body: formDataFundo,
        });

        if (!resFundo.ok) throw new Error("Erro no upload da imagem de fundo");
        const dataFundo = await resFundo.json();
        fundoUrl = dataFundo.url;
      }

      // 3. Upload do Favicon <-- NOVO
      if (faviconSelecionado) {
        const formDataFavicon = new FormData();
        formDataFavicon.append("file", faviconSelecionado);
        formDataFavicon.append("cliente_id", currentData.id);

        const resFavicon = await fetch("/api/upload", {
          method: "POST",
          body: formDataFavicon,
        });

        if (!resFavicon.ok) throw new Error("Erro no upload do favicon");
        const dataFavicon = await resFavicon.json();
        faviconUrl = dataFavicon.url;
      }

      // 4. Monta o payload final incluindo o favicon
      const payload = { 
        ...currentData, 
        logo: logoUrl, 
        imagem_fundo: fundoUrl,
        favicon: faviconUrl // <-- NOVO
      };

      await api.put(`/sites/${currentData.id}`, payload);

      alert("Configurações atualizadas com sucesso!");
      setArquivoSelecionado(null);
      setFundoSelecionado(null);
      setFaviconSelecionado(null); // Limpa o estado
      loadSite();
    } catch (error) {
      console.error(error);
      alert("Erro ao atualizar configurações.");
    } finally {
      setIsLoading(false);
    }
  };

  const removeLogo = () => {
    setSite({ ...site, logo: "" });
    setArquivoSelecionado(null);
  };

  const removeFundo = () => {
    setSite({ ...site, imagem_fundo: "" });
    setFundoSelecionado(null);
  };

  // Limpa o Favicon <-- NOVO
  const removeFavicon = () => {
    setSite({ ...site, favicon: "" });
    setFaviconSelecionado(null);
  };

  if (!site) {
    return (
      <div className="dashboard-loading">
        <Loader2 className="spinner" size={40} />
        <p>Carregando informações do instituto...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-wrapper">
        
        <div className="dashboard-header">
          <div className="dashboard-title">
            <h1>Configurações do Portal</h1>
            <p>Ajuste a identidade visual e informações institucionais.</p>
          </div>
        </div>

        <div className="config-card">
          <div className="config-grid">
            
            {/* LADO ESQUERDO: GESTÃO DE IMAGENS */}
            <div>
              {/* --- BLOCO 1: LOGOMARCA --- */}
              <div className="config-section">
                <div className="section-title">
                  <ImageIcon size={18} />
                  <h3>Logomarca Principal</h3>
                </div>
                
                <div className="logo-management">
                  <div className="logo-preview-box">
                    {site.logo ? (
                      <img src={site.logo} alt="Logo Atual" />
                    ) : (
                      <div className="no-logo">
                        <ImageIcon size={32} />
                        <span>Nenhuma logo definida</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="logo-actions">
                    <label className="btn btn-secondary btn-sm">
                      <Upload size={16} /> Alterar
                      <input type="file" hidden onChange={handleFileChange} accept="image/*" />
                    </label>
                    
                    {(site.logo || arquivoSelecionado) && (
                      <button 
                        className="btn btn-danger btn-sm"
                        onClick={removeLogo}
                        title="Remover logo"
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>

                  {arquivoSelecionado && (
                    <p className="file-selected-name">
                      Pronto para enviar: {arquivoSelecionado.name}
                    </p>
                  )}
                </div>
              </div>

              {/* --- BLOCO 2: FAVICON DA GUIA (NOVO) --- */}
              <div className="config-section mt-4">
                <div className="section-title">
                  <Globe size={18} />
                  <h3>Ícone da Aba (Favicon)</h3>
                </div>
                
                <div className="logo-management">
                  <div className="logo-preview-box" style={{ height: "100px" }}>
                    {site.favicon ? (
                      <img 
                        src={site.favicon} 
                        alt="Favicon Atual" 
                        style={{ width: "40px", height: "40px", objectFit: "contain" }} 
                      />
                    ) : (
                      <div className="no-logo">
                        <Globe size={28} />
                        <span>Usando brasão/logo padrão</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="logo-actions">
                    <label className="btn btn-secondary btn-sm">
                      <Upload size={16} /> Alterar
                      <input 
                        type="file" 
                        hidden 
                        onChange={handleFaviconChange} 
                        accept=".ico,.png,.svg,image/x-icon,image/png" 
                      />
                    </label>
                    
                    {(site.favicon || faviconSelecionado) && (
                      <button 
                        className="btn btn-danger btn-sm"
                        onClick={removeFavicon}
                        title="Remover favicon"
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>

                  <small className="form-help" style={{ display: "block", marginTop: "6px" }}>
                    Recomendado: imagem quadrada (.ico ou .png de 32x32px).
                  </small>

                  {faviconSelecionado && (
                    <p className="file-selected-name">
                      Pronto para enviar: {faviconSelecionado.name}
                    </p>
                  )}
                </div>
              </div>

              {/* --- BLOCO 3: IMAGEM DE FUNDO --- */}
              <div className="config-section mt-4">
                <div className="section-title">
                  <MonitorPlay size={18} />
                  <h3>Imagem de Fundo</h3>
                </div>
                
                <div className="logo-management">
                  <div className="logo-preview-box">
                    {site.imagem_fundo ? (
                      <img src={site.imagem_fundo} alt="Fundo Atual" style={{ objectFit: "cover" }} />
                    ) : (
                      <div className="no-logo">
                        <ImageIcon size={32} />
                        <span>Nenhum fundo definido</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="logo-actions">
                    <label className="btn btn-secondary btn-sm">
                      <Upload size={16} /> Alterar
                      <input type="file" hidden onChange={handleFundoChange} accept="image/*" />
                    </label>
                    
                    {(site.imagem_fundo || fundoSelecionado) && (
                      <button 
                        className="btn btn-danger btn-sm"
                        onClick={removeFundo}
                        title="Remover fundo"
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>

                  {fundoSelecionado && (
                    <p className="file-selected-name">
                      Pronto para enviar: {fundoSelecionado.name}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* LADO DIREITO: INFORMAÇÕES E CORES */}
            <div className="config-section">
              <div className="section-title">
                <Building size={18} />
                <h3>Informações Gerais</h3>
              </div>

              <div className="form-group">
                <label className="form-label">Nome da Instituição</label>
                <input 
                  className="form-input"
                  value={site.nome || ""}
                  onChange={(e) => setSite({ ...site, nome: e.target.value })}
                  placeholder="Ex: Instituto de Previdência..."
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <MapPin size={14} className="inline-icon"/> URL do Mapa (Embed)
                </label>
                <input 
                  className="form-input"
                  placeholder="https://www.google.com/maps/embed?pb=..."
                  value={site.endereco_mapa || ""}
                  onChange={(e) => setSite({ ...site, endereco_mapa: e.target.value })}
                />
                <small className="form-help">
                  No Google Maps, vá em Compartilhar {'>'} Incorporar mapa e copie apenas o link dentro de 'src'.
                </small>
              </div>

              <div className="section-title mt-4">
                <Palette size={18} />
                <h3>Identidade Visual</h3>
              </div>

              <div className="color-picker-group">
                <div className="color-field">
                  <label className="form-label">Cor Primária</label>
                  <div className="color-input-wrapper">
                    <input 
                      type="color" 
                      value={site.cor_primaria || "#1e3a8a"}
                      onChange={(e) => setSite({ ...site, cor_primaria: e.target.value })}
                    />
                    <span>{site.cor_primaria || "#1e3a8a"}</span>
                  </div>
                </div>

                <div className="color-field">
                  <label className="form-label">Cor Secundária</label>
                  <div className="color-input-wrapper">
                    <input 
                      type="color" 
                      value={site.cor_secundaria || "#64748b"}
                      onChange={(e) => setSite({ ...site, cor_secundaria: e.target.value })}
                    />
                    <span>{site.cor_secundaria || "#64748b"}</span>
                  </div>
                </div>
              </div>

              {/* INFORMAÇÕES DO RODAPÉ */}
              <div className="section-title mt-4">
                <PanelBottom size={18} />
                <h3>Informações do Rodapé</h3>
              </div>

              <div className="color-picker-group">
                <div className="form-group">
                  <label className="form-label">CNPJ</label>
                  <input 
                    className="form-input"
                    value={site.rodape?.cnpj || ""}
                    onChange={(e) => handleRodapeChange('cnpj', e.target.value)}
                    placeholder="00.000.000/0000-00"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Contato (Telefone)</label>
                  <input 
                    className="form-input"
                    value={site.rodape?.telefone || ""}
                    onChange={(e) => handleRodapeChange('telefone', e.target.value)}
                    placeholder="(00) 00000-0000"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">E-mail</label>
                <input 
                  className="form-input"
                  type="email"
                  value={site.rodape?.email || ""}
                  onChange={(e) => handleRodapeChange('email', e.target.value)}
                  placeholder="contato@instituto.com.br"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Endereço Completo</label>
                <input 
                  className="form-input"
                  value={site.rodape?.endereco || ""}
                  onChange={(e) => handleRodapeChange('endereco', e.target.value)}
                  placeholder="Avenida Rio Grande do Sul, 1345..."
                />
              </div>

            </div>
          </div>

          <div className="config-footer">
            <button 
              className="btn btn-primary"
              disabled={isLoading}
              onClick={() => handleUpdateSite(site)}
            >
              {isLoading ? (
                <>
                  <Loader2 className="spinner" size={18} /> Salvando...
                </>
              ) : (
                <>
                  <Save size={18} /> Salvar Alterações
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}